import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const submitLead = (data) => axios.post(`${API}/leads`, data);
export const joinWaitlist = (email) => axios.post(`${API}/waitlist`, { email });
export const fetchLeads = (key) => axios.get(`${API}/leads`, { headers: { "X-Admin-Key": key } });
export const fetchWaitlist = (key) => axios.get(`${API}/waitlist`, { headers: { "X-Admin-Key": key } });
